import { isArray, isBoolean, isNumber, isPlainObject, isString, toString } from 'lodash';
import { TBaseTagContext } from '../types';
import { UniversalTag } from '.';
import { TBaseTag } from '../CustomTag/types';
import React from 'react';

const UniversalChildren: React.FC<{
  children: TBaseTag['children'];
  context: Partial<TBaseTagContext>;
  index?: string;
}> = React.memo(({ children, context, index }) => {
  if (children !== undefined && children !== null) {
    if (isString(children) || isNumber(children) || isBoolean(children)) {
      return <>{toString(children)}</>;
    }
    if (isArray(children)) {
      return (
        <>
          {children.map((child, i) => (
            <UniversalChildren context={context} index={`${index ? index + '-' : ''}${i}`} key={i}>
              {child}
            </UniversalChildren>
          ))}
        </>
      );
    }
    if (isPlainObject(children) && isString(children.tag))
      return <UniversalTag tagProps={children} context={context} key={index} />;
    return null;
  }
  return null;
});
UniversalChildren.displayName = 'UniversalChildren';
export default UniversalChildren;
